import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Chip from 'components/common/Chip';

import dateFormat from 'config/dateFormat';

const styles = theme => ({
  typography: {
    marginRight: 8,
  },
  typographyDate: {
    marginRight: 8,
  },
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    overflow: 'hidden',
    padding: '8px 16px 8px 16px',
    backgroundColor: theme.palette.primary[50],
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
  },
});

const ProductClaimRefillDatesField = ({ name, classes, ...fields }) => {
  const type = get(fields, `${name}.Type`);
  const refill = get(fields, `${name}.Refill`);
  const dateOfServiceFrom = get(fields, `${name}.dateOfServiceFrom`);
  if (type.input.value
    && (type.input.value === 'Recurring' || type.input.value === 'Rental')
    && refill.input.value && refill.input.value > 0
    && dateOfServiceFrom.input.value && !dateOfServiceFrom.meta.error) {
    const date = moment(dateOfServiceFrom.input.value, dateFormat);
    const dates = [];
    for (let i = 1; i <= refill.input.value; i += 1) {
      const refillDate = type.input.value === 'Recurring' 
        ? date.clone().add(i*30, 'days').format(dateFormat)
        : date.clone().add(i, 'month').format(dateFormat);
      dates.push(refillDate);
    }
    return (
      <div className={classes.root}>
        <Typography
          className={classes.typography}
        >
          Future Refills:
        </Typography>
        {dates.map(item => (
          <Typography
            className={classes.typographyDate}
            color="primary"
            key={item}
          >
            {item}
          </Typography>
        ))}
      </div>
    );
  }
  return '';
};

ProductClaimRefillDatesField.propTypes = {
  name: PropTypes.string.isRequired,
  classes: PropTypes.shape({
    typography: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(ProductClaimRefillDatesField);



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaim/ProductClaimRefillDatesField.js